import { forwardRef, type KeyboardEventHandler, type MouseEvent, type ReactNode, type Ref } from 'react';
import type { LinkInfo } from '../../types';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import LinkOrNativeAnchor from '../LinkOrNativeAnchor/LinkOrNativeAnchor';

type LinkInfoRendererProps = {
  ariaLabel?: string;
  children: ReactNode;
  className?: string;
  'data-denali'?: string;
  dataTooltipId?: string;
  linkInfo: LinkInfo;
  onBlur?: () => void;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  onContextMenu?: (e: MouseEvent<HTMLElement>) => void;
  onFocus?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLElement>;
  onMouseEnter?: (e: MouseEvent<HTMLElement>) => void;
  onMouseLeave?: (e: MouseEvent<HTMLElement>) => void;
  role?: string;
  tabIndex?: number;
  testId?: string;
  title?: string;
};

const LinkInfoRenderer = (
  {
    ariaLabel,
    children,
    className,
    'data-denali': dataDenali,
    dataTooltipId,
    linkInfo,
    onBlur,
    onClick,
    onContextMenu,
    onFocus,
    onKeyDown,
    onMouseEnter,
    onMouseLeave,
    role,
    tabIndex = 0,
    testId,
    title
  }: LinkInfoRendererProps,
  ref: Ref<HTMLAnchorElement>
) => {
  const { rel, target, href, isNativeLink, prefetch } = linkInfo;
  const linkProps = {
    'aria-label': ariaLabel,
    className,
    ...setDenaliAttribute(dataDenali || 'LinkInfoRenderer'),
    'data-testid': testId,
    'data-tooltip-id': dataTooltipId,
    href,
    isNativeLink,
    onBlur,
    onClick,
    onContextMenu,
    onFocus,
    onKeyDown,
    onMouseEnter,
    onMouseLeave,
    prefetch,
    ref,
    rel,
    role,
    target,
    tabIndex,
    title
  };

  return <LinkOrNativeAnchor {...linkProps}>{children}</LinkOrNativeAnchor>;
};

export default forwardRef(LinkInfoRenderer);
